export enum AccountTypeEnum {
  Retailer = 1,
  Supplier = 2,
  Provider = 3,
  VoltSystems = 9,
}
